import { render, staticRenderFns } from "./SuaDonVi.vue?vue&type=template&id=c056fe8c&"
import script from "./SuaDonVi.vue?vue&type=script&lang=js&"
export * from "./SuaDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports